import { createFileRoute } from "@tanstack/react-router";
import SpacedRepetitionGuideFr from "@/pages/resources/fr/SpacedRepetitionGuideFr";

export const Route = createFileRoute("/fr/learn/spaced-repetition")({
  head: () => ({
    meta: [
        {
            "title": "La répétition espacée : la science de la mémoire à long terme | System Atlas"
        },
        {
            "name": "description",
            "content": "Apprenez comment la répétition espacée optimise la rétention. Guide avec intervalles optimaux et stratégies pratiques."
        },
        {
            "property": "og:title",
            "content": "La répétition espacée : la science de la mémoire à long terme | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Apprenez comment la répétition espacée optimise la rétention. Guide avec intervalles optimaux et stratégies pratiques."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/fr/learn/spaced-repetition"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "La répétition espacée : la science de la mémoire à long terme | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Apprenez comment la répétition espacée optimise la rétention. Guide avec intervalles optimaux et stratégies pratiques."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/fr/learn/spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/spaced-repetition"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/spaced-repetition"
        }
    ],
  }),
  component: SpacedRepetitionGuideFr,
});
